export const formatDateYYYYMMDD = (d) =>
  d
    ? [
        d.getFullYear(),
        (d.getMonth() + 1).toString().padStart(2, "0"),
        d.getDate().toString().padStart(2, "0"),
      ].join("-")
    : "";

export const getRecurringDonationPayloadDigio = ({
  recurringState,
  formData,
}) => {
  const {
    name: firstName,
    city,
    state,
    country,
    address,
    phone: phoneNumber,
    email: emailAddress,
    postalCode,
    citizenship,
    amount,
    identificationNumber,
    identificationType,
    memberId,
    currency,
    donation_id,
    paymentSuccessUrl: redirectUrl,
    meditation_place = null,
    srcmGroupCompleteName = null,
    meditation_place_others = null,
  } = formData;
  const payload = {
    amount,
    firstName,
    lastName: null,
    emailAddress,
    phoneNumber,
    city,
    state,
    country,
    postalCode,
    address,
    citizenship,
    pancard: identificationType === "Pancard" ? identificationNumber : "",
    identificationType,
    identificationNumber:
      identificationType !== "Pancard" ? identificationNumber : "",
    memberId,
    currency,
  };

  const { donation_type, onlineSectionDetails, offlineSectionDetails } =
    recurringState;
  const keys = {
    STANDING_INSTRUCTION:
      "Standing Instruction with donor’s bank for making recurring donations",
    INTERNET_BANKING: "Internet banking",
  };
  Object.assign(payload, {
    donationType: donation_type,
  });
  switch (donation_type) {
    case "ONLINE":
      {
        const { account_type, start_date, end_date } = onlineSectionDetails;
        Object.assign(payload, {
          accountType: account_type,
          period: "Monthly",
          startDate: formatDateYYYYMMDD(start_date),
          endDate: formatDateYYYYMMDD(end_date),
        });
      }
      break;
    case "OFFLINE":
      {
        const { payment_option, standingInstructionDetails } =
          offlineSectionDetails;
        Object.assign(payload, {
          paymentOption: payment_option,
        });
        switch (payment_option) {
          case keys.STANDING_INSTRUCTION:
            {
              const { payment_mode, netBankingDetails, walletDetails } =
                standingInstructionDetails;
              Object.assign(payload, {
                paymentMode: payment_mode,
                periodOfStandingInstruction: "Monthly",
              });
              switch (payment_mode) {
                case keys.INTERNET_BANKING:
                  {
                    const { donor_bank, donor_ifsc_code, standing_date } =
                      netBankingDetails;
                    Object.assign(payload, {
                      donorBank: donor_bank,
                      donorIFSCCode: donor_ifsc_code,
                      dateOfStandingInstruction:
                        formatDateYYYYMMDD(standing_date),
                    });
                  }
                  break;
                case "WALLET":
                  {
                    const { wallet_mobile, standing_date } = walletDetails;
                    Object.assign(payload, {
                      mobileNumberLinkedToWallet: wallet_mobile,
                      dateOfStandingInstruction:
                        formatDateYYYYMMDD(standing_date),
                    });
                  }
                  break;
                default:
                  break;
              }
            }
            break;

          case "ECS Donations":
            break;
          default:
            break;
        }
      }
      break;
    default:
      break;
  }

  const newData = {
    customerDetail: payload,
    otherDetail: {
      donationItemId: donation_id,
      redirectUrl,
    },
  };
  if (meditation_place && meditation_place !== "Others") {
    newData.otherDetail.meditationPlace = meditation_place;
    newData.otherDetail.center = srcmGroupCompleteName;
  } else if (
    meditation_place &&
    meditation_place_others &&
    meditation_place === "Others"
  ) {
    newData.otherDetail.meditationPlace = meditation_place_others;
    newData.otherDetail.center = meditation_place_others;
  }
  return newData;
};

export const getRecurringPayloadAuthorizeDotNet = ({
  recurringState,
  formData,
}) => {
  const {
    name: firstName,
    lastName,
    city,
    state,
    country,
    address,
    phone: phoneNumber,
    email: emailAddress,
    postalCode,
    citizenship,
    currency,
    amount,
    donation_id,
    city_id: cityId,
    paymentSuccessUrl: redirectUrl,
    meditation_place = null,
    srcmGroupCompleteName = null,
    meditation_place_others = null,
  } = formData;

  const { onlineSectionDetails: recurringData } = recurringState;

  const payload = {
    customerDetail: {
      firstName,
      lastName,
      city,
      state,
      country,
      address,
      phoneNumber,
      emailAddress,
      postalCode,
      citizenship,
      currency,
      amount,
      period: "Monthly",
      startDate: formatDateYYYYMMDD(recurringData.start_date),
      endDate: formatDateYYYYMMDD(recurringData.end_date),
      accountType: recurringData.account_type,
      cityId,
      donationType: "ONLINE",
    },
    otherDetail: {
      donationItemId: donation_id,
      redirectUrl,
    },
  };
  if (meditation_place && meditation_place !== "Others") {
    payload.otherDetail.meditationPlace = meditation_place;
    payload.otherDetail.center = srcmGroupCompleteName;
  } else if (
    meditation_place &&
    meditation_place_others &&
    meditation_place === "Others"
  ) {
    payload.otherDetail.meditationPlace = meditation_place_others;
    payload.otherDetail.center = meditation_place_others;
  }
  return payload;
};

export const getOfflinePayloadData = (offlineDonationState, formData) => {
  const {
    name: firstName,
    lastName,
    address: addressLine1,
    email: emailAddress,
    phone: phoneNumber,
    citizenship: citizenshipCountry,
    amount,
    donation_id: id,
    identificationType,
    identificationNumber,
    memberId,
    city,
    state,
    postalCode,
    country,
    meditation_place = null,
    srcmGroupCompleteName = null,
    meditation_place_others = null,
  } = formData;
  const {
    payment_option: paymentOption,
    donationByCheque,
    donationByNEFT,
  } = offlineDonationState.offlineSectionDetails;
  const { chequeNo, chequeBankName, chequeDate } = donationByCheque;
  const { accountNo, neftBankName, ifscCode: ifsc } = donationByNEFT;

  const payload = {
    userProfile: {
      firstName,
      lastName: lastName || "",
      addressLine1,
      emailAddress,
      phoneNumber,
      citizenshipCountry,
      taxId:
        identificationNumber && identificationType === "Pancard"
          ? identificationNumber
          : "",
      city,
      state,
      country,
      postalCode,
    },
    refDate: formatDateYYYYMMDD(new Date()),
    paymentOption,
    amount,
    campaign: {
      id,
    },
    bankName: neftBankName || chequeBankName,
    ifsc,
    accountNo,
    chequeNo,
    chequeDate: formatDateYYYYMMDD(chequeDate) || null,
    extras: {
      memberId,
      currency: formData.currency,
    },
  };
  if (meditation_place && meditation_place !== "Others") {
    payload.extras.meditationPlace = meditation_place;
    payload.extras.center = srcmGroupCompleteName;
  } else if (
    meditation_place &&
    meditation_place_others &&
    meditation_place === "Others"
  ) {
    payload.extras.meditationPlace = meditation_place_others;
    payload.extras.center = meditation_place_others;
  }
  return payload;
};
